// Fragment « divers » (DE): Über uns, Kontakt, Kundenbewertungen, Cookie-Banner.
// Gleiche Schlüssel wie fr/divers.js, Werte auf Deutsch.
export default {
  // ---- Über uns (pages/About.jsx) ----
  'apropos.seo.titre': 'Über uns',
  'apropos.seo.description': 'Entdecken Sie die Geschichte von Mirum Games und unsere Leidenschaft, mit Joyful Reveal magische Familienmomente zu schaffen — Puzzles aus hochwertigen Materialien.',
  'apropos.hero.badge': '🎮 Unsere Geschichte',
  'apropos.hero.titre': 'Willkommen bei Mirum Games',
  'apropos.hero.texte': 'Wir schaffen magische Momente, um die Ankunft Ihres Babys zu feiern und diese Freude mit der ganzen Familie zu teilen.',
  'apropos.mission.titre': 'Unsere Mission',
  'apropos.mission.texte1': 'Bei Mirum Games glauben wir, dass die wichtigen Momente im Leben es verdienen, auf einzigartige und unvergessliche Weise gefeiert zu werden. Unsere Mission ist es, festliche und interaktive Erlebnisse zu schaffen, die aus der Enthüllung des Geschlechts des Babys einen unvergesslichen Moment mit der ganzen Familie machen.',
  'apropos.mission.texte2': 'Jedes Puzzle ist mit Sorgfalt gestaltet, um einen Moment voller Spannung und Freude zu schaffen — mit außergewöhnlicher Qualität und einem Erlebnis, das der ganzen Familie in Erinnerung bleibt.',
  'apropos.mission.encart.titre': 'Spielerisch feiern',
  'apropos.mission.encart.texte': 'Aus der Enthüllung ein lustiges Frage-und-Antwort-Spiel machen, bei dem alle mitmachen',
  'apropos.mission.carte1.titre': 'Spannung',
  'apropos.mission.carte1.texte': 'Einen unvergesslichen Moment voller Spannung und Vorfreude schaffen',
  'apropos.mission.carte2.titre': 'Feststimmung',
  'apropos.mission.carte2.texte': 'Aus der Enthüllung ein festliches und unvergessliches Ereignis machen',
  'apropos.mission.carte3.titre': 'Gemeinsam erleben',
  'apropos.mission.carte3.texte': 'Wertvolle Momente mit der Familie',
  'apropos.valeurs.titre': 'Unsere Grundwerte',
  'apropos.valeurs.soustitre': 'Die Prinzipien, die jede unserer Entscheidungen leiten',
  'apropos.valeurs.excellence.titre': 'Exzellenz',
  'apropos.valeurs.excellence.texte': 'Bei der Qualität gehen wir nie Kompromisse ein. Jedes Detail zählt, vom Entwurf bis zur Verarbeitung des Puzzles.',
  'apropos.valeurs.creativite.titre': 'Kreativität',
  'apropos.valeurs.creativite.texte': 'Wir entwickeln uns ständig weiter, um einzigartige und unvergessliche Enthüllungsmomente zu schaffen, die im Gedächtnis bleiben.',
  'apropos.valeurs.authenticite.titre': 'Authentizität',
  'apropos.valeurs.authenticite.texte': 'Wir bleiben unseren Werten treu und stehen zu unserem Engagement für unsere Kunden und unsere Community.',
  'apropos.valeurs.innovation.titre': 'Innovation',
  'apropos.valeurs.innovation.texte': 'Wir suchen ständig nach neuen Wegen, um außergewöhnliche Feiermomente zu schaffen.',
  'apropos.valeurs.emotions.titre': 'Emotionen',
  'apropos.valeurs.emotions.texte': 'Wir schaffen Momente voller Emotionen, die der ganzen Familie in Erinnerung bleiben.',
  'apropos.valeurs.passion.titre': 'Leidenschaft',
  'apropos.valeurs.passion.texte': 'Wir lieben, was wir tun — und das spürt man in jedem Produkt.',
  'apropos.reseaux.titre': 'Unsere sozialen Netzwerke',
  'apropos.reseaux.soustitre': 'Werden Sie Teil unserer Community und schauen Sie hinter die Kulissen',
  'apropos.reseaux.instagram.texte': 'Entdecken Sie unsere neuesten Kreationen, blicken Sie hinter die Kulissen unserer Puzzles und teilen Sie Ihre magischen Momente mit #MirumGames',
  'apropos.reseaux.facebook.texte': 'Werden Sie Teil unserer Community, nehmen Sie an Gewinnspielen teil und bleiben Sie über unsere exklusiven Angebote und Neuheiten auf dem Laufenden',
  'apropos.processus.titre': 'Unser Kreativprozess',
  'apropos.processus.soustitre': 'Von der Idee bis zu Ihnen nach Hause',
  'apropos.processus.etape1.titre': 'Recherche & Ideen',
  'apropos.processus.etape1.texte': 'Wir hören werdenden Eltern und allen zu, die eine Gender-Reveal-Party organisieren, um Erlebnisse zu schaffen, die noch länger in Erinnerung bleiben.',
  'apropos.processus.etape2.titre': 'Entwurf & Tests',
  'apropos.processus.etape2.texte': 'Unser Team gestaltet jedes Puzzle und testet alles gründlich, damit das Spiel Spaß macht und der Moment in Erinnerung bleibt.',
  'apropos.processus.etape3.titre': 'Herstellung',
  'apropos.processus.etape3.texte': 'Jedes Puzzle wird mit Sorgfalt und Liebe zum Detail gefertigt, für eine Premiumqualität.',
  'apropos.processus.etape4.titre': 'Qualität & Versand',
  'apropos.processus.etape4.texte': 'Jedes Spiel durchläuft eine strenge Qualitätskontrolle, bevor es sorgfältig zu Ihnen nach Hause geschickt wird.',
  'apropos.cta.titre': 'Bereit, unsere Spiele zu entdecken?',
  'apropos.cta.texte': 'Entdecken Sie unsere gesamte Kollektion und machen Sie aus der Enthüllung des Geschlechts Ihres Babys einen magischen und unvergesslichen Moment.',
  'apropos.cta.boutique': '🛍️ Shop entdecken',
  'apropos.cta.contact': '💬 Kontakt aufnehmen',

  // ---- Kontakt (pages/Contact.jsx) ----
  'contact.seo.titre': 'Kontakt',
  'contact.seo.description': 'Kontaktiere Mirum Games bei allen Fragen zu Joyful Reveal, zu unserem Spiel oder zu deinen Bestellungen. Schnelle Antwort garantiert.',
  'contact.hero.badge': '💬 Bleiben wir in Kontakt',
  'contact.hero.titre': 'Wir hören gern von Ihnen',
  'contact.hero.texte': 'Fragen? Anregungen? Schreiben Sie uns einfach. Wir antworten in der Regel innerhalb von 24 Stunden.',
  'contact.cartes.email.titre': 'E-Mail',
  'contact.cartes.email.texte': 'Antwort in 24-48 Std.',
  'contact.cartes.adresse.titre': 'Adresse',
  'contact.cartes.adresse.ligne1': 'Rue de la Cortaille, 59',
  'contact.cartes.adresse.ligne2': '6800 Freux, Belgien',
  'contact.cartes.faq.titre': 'Fragen?',
  'contact.cartes.faq.texte': 'Sehen Sie in unsere FAQ',
  'contact.cartes.faq.soustexte': 'Sofort eine Antwort',
  'contact.formulaire.titre': 'Schreiben Sie uns eine Nachricht',
  'contact.formulaire.nom': 'Ihr Name',
  'contact.formulaire.nomPlaceholder': 'Max Mustermann',
  'contact.formulaire.email': 'E-Mail',
  'contact.formulaire.emailPlaceholder': 'ihre@email.com',
  'contact.formulaire.sujet': 'Betreff',
  'contact.formulaire.sujetPlaceholder': '-- Betreff auswählen --',
  'contact.formulaire.sujetCommande': 'Frage zu meiner Bestellung',
  'contact.formulaire.sujetProduit': 'Frage zu einem Produkt',
  'contact.formulaire.sujetLivraison': 'Frage zur Lieferung',
  'contact.formulaire.sujetPartenariat': 'Partnerschaft',
  'contact.formulaire.sujetAutre': 'Sonstiges',
  'contact.formulaire.message': 'Nachricht',
  'contact.formulaire.messagePlaceholder': 'Ihre Nachricht hier...',
  'contact.formulaire.envoiEnCours': '⏳ Wird gesendet...',
  'contact.formulaire.envoyer': '📬 Nachricht senden',
  'contact.formulaire.succes': '✨ Danke für Ihre Nachricht! Wir melden uns sehr bald bei Ihnen.',
  'contact.faq.titre': 'Häufige Fragen',
  'contact.faq.soustitre': 'Vielleicht steht Ihre Antwort schon hier',
  'contact.faq.q1': '❓ Wie lange dauert die Lieferung?',
  'contact.faq.a1': "Die Bestellungen verlassen Belgien im Schnitt innerhalb eines Werktags. Rechnen Sie danach mit 1 bis 2 Werktagen für Luxemburg, Belgien und die Niederlande, 2 bis 4 Tagen für Frankreich und Deutschland und 4 bis 5 Tagen für Spanien.",
  'contact.faq.q2': '🎁 Kann ich eine persönliche Nachricht hinzufügen?',
  'contact.faq.a2': 'Natürlich! Unsere Premium-Packs enthalten eine personalisierte Karte. Melden Sie sich nach Ihrer Bestellung bei uns, dann klären wir die Einzelheiten.',
  'contact.faq.q3': '💰 Gibt es eine Garantie?',
  'contact.faq.a3': 'Ja! Sie haben 14 Tage Zeit, ein Produkt zurückzuschicken, das Ihnen nicht zusagt. Außerdem gewähren wir auf alle unsere Produkte Garantie gegen versteckte Mängel.',
  'contact.faq.q4': '🌍 Liefern Sie auch ins Ausland?',
  'contact.faq.a4': "Wir liefern nach Belgien, Frankreich, Luxemburg, in die Niederlande, nach Deutschland und Spanien. Beim Bestellen wählen Sie zwischen Haustürlieferung und Abholpunkt, je nachdem, welche Dienstleister an Ihrer Adresse verfügbar sind.",
  'contact.faq.q5': '🎮 Wie funktioniert das Puzzle?',
  'contact.faq.a5': 'Es ist ein lustiges Frage-und-Antwort-Spiel, das durch das Zusammenlegen des Puzzles führt. Mit jeder richtigen Antwort legen Sie Teile an — bis Sie erfahren, ob es ein Junge oder ein Mädchen wird!',
  'contact.faq.q6': '🎊 Mit wie vielen Personen kann man spielen?',
  'contact.faq.a6': 'Das Puzzle ist gemacht, um es mit der ganzen Familie zu spielen! Sie können Teams bilden und zu mehreren spielen, damit der Moment noch festlicher wird.',
  'contact.newsletter.titre': 'Bleiben Sie informiert',
  'contact.newsletter.texte': 'Melden Sie sich für unseren Newsletter an und erhalten Sie unsere neuesten Angebote und Neuigkeiten',
  'contact.newsletter.emailPlaceholder': 'ihre@email.com',
  'contact.newsletter.inscrire': 'Anmelden',
  'contact.newsletter.succes': '✨ Willkommen in unserem Newsletter!',

  // ---- Kundenbewertungen (components/Reviews/*) ----
  // Der INHALT der Bewertungen (Text, Titel, Name des Verfassers) kommt aus der
  // Datenbank und wird nie übersetzt; nur der Rahmen nutzt diese Schlüssel.
  'avis.section.badge': '💬 Kundenerfahrungen',
  'avis.section.titre': 'Was unsere Kunden begeistert',
  'avis.section.accrocheAucun': 'Schon gespielt? Erzählen Sie uns von Ihrem Moment — Ihre Bewertung hilft den nächsten werdenden Eltern bei der Entscheidung.',
  'avis.section.accrochePeu': 'Andere haben vor Ihnen gespielt und sich die Zeit genommen, uns zu schreiben. Hier sind ihre Worte, ungefiltert.',
  'avis.section.accrocheNombreux': 'Schon {n} Familien haben ihren Moment mit uns geteilt.',
  'avis.section.compteurSingulier': 'Bewertung',
  'avis.section.compteurPluriel': 'Bewertungen',
  'avis.section.premierAvis': 'Geben Sie als Erster Ihre Bewertung ab!',
  'avis.section.fermer': '✕ Schließen',
  'avis.section.laisserAvis': '✍️ Bewertung schreiben',
  'avis.section.chargement': 'Bewertungen werden geladen...',
  'avis.section.listeTitre': 'Die Bewertungen',
  'avis.section.aucunTitre': 'Seien Sie der Erste!',
  'avis.section.aucunTexte': 'Noch keine Bewertungen. Teilen Sie als Erster Ihr magisches Erlebnis!',
  'avis.section.ecrirePremier': 'Die erste Bewertung schreiben',
  'avis.section.erreurEnvoi': 'Fehler beim Senden der Bewertung',
  'avis.carte.noteAria': 'Bewertung {note} von 5',
  'avis.carte.clientVerifie': 'Verifizierter Kunde',
  'avis.carte.achatVerifie': '✅ Verifizierter Kauf',
  'avis.formulaire.titre': 'Teilen Sie Ihre Erfahrung',
  'avis.formulaire.note': 'Gesamtbewertung',
  'avis.formulaire.noterAria': '{n} Sterne geben',
  'avis.formulaire.note5': 'Ausgezeichnet! 🤩',
  'avis.formulaire.note4': 'Sehr gut 🙂',
  'avis.formulaire.note3': 'Gut 😐',
  'avis.formulaire.note2': 'Mittelmäßig 😕',
  'avis.formulaire.note1': 'Enttäuscht 😞',
  'avis.formulaire.titreAvis': 'Titel Ihrer Bewertung',
  'avis.formulaire.titrePlaceholder': 'Z. B.: Tolles Puzzle, meine Tochter liebt es!',
  'avis.formulaire.commentaire': 'Ihr Kommentar',
  'avis.formulaire.commentairePlaceholder': 'Sagen Sie uns, was Ihnen gefallen hat...',
  'avis.formulaire.envoiEnCours': 'Wird gesendet...',
  'avis.formulaire.publier': 'Meine Bewertung veröffentlichen',

  // ---- Cookie-Banner (components/CookieConsent.jsx) ----
  'cookies.bandeau.titre': '🍪 Cookie-Verwaltung',
  'cookies.bandeau.texte': "Diese Website nutzt nur zweierlei: die Cookies, die Ihr Warenkorb und Ihre Anmeldung brauchen, und eine anonyme Reichweitenmessung, die wir selbst durchführen — ohne Cookie und ohne Sie je zu identifizieren. Keine Werbung, kein Profiling, keine Weitergabe an Dritte.",
  'cookies.gerer': "Meine Cookies verwalten",
  'cookies.categories.necessaires': 'Notwendige Cookies',
  'cookies.categories.necessairesDesc': 'Immer aktiv - Unverzichtbar für den Betrieb der Website',
  'cookies.categories.analytics': "Anonyme Reichweitenmessung",
  'cookies.categories.analyticsDesc': "Anzahl der Besuche und aufgerufene Seiten. Ohne Cookie, ohne Kennung, Ihre IP-Adresse wird nie gespeichert. Sie können sie ablehnen.",
  'cookies.categories.marketing': 'Marketing-Cookies',
  'cookies.categories.marketingDesc': 'Um Ihnen personalisierte Inhalte und Angebote anzubieten',
  'cookies.bandeau.voirNotre': 'Lesen Sie unsere',
  'cookies.bandeau.politique': 'Datenschutzerklärung',
  'cookies.bandeau.plusInfos': 'für weitere Informationen',
  'cookies.actions.refuser': 'Alle ablehnen',
  'cookies.actions.personnaliser': 'Anpassen',
  'cookies.actions.accepter': 'Alle akzeptieren',

  // --- Connexion, inscription, profil ---
  // Ces trois pages n'etaient pas traduites du tout : un visiteur allemand
  // cliquait « Anmelden » dans une barre de navigation allemande et recevait
  // un formulaire entierement francais.
  'compte.connexion.seoTitre': "Anmelden",
  'compte.connexion.seoDescription': "Melden Sie sich bei Ihrem Mirum-Games-Konto an.",
  'compte.connexion.titre': "Anmelden",
  'compte.connexion.sousTitre': "Willkommen bei Mirum Games",
  'compte.champ.email': "E-Mail-Adresse",
  'compte.champ.emailPlaceholder': "ihre@email.com",
  'compte.champ.motDePasse': "Passwort",
  'compte.champ.motDePassePlaceholder': "Ihr Passwort",
  'compte.champ.basculerMotDePasse': "Passwort ein- oder ausblenden",
  'compte.connexion.seSouvenir': "Angemeldet bleiben",
  'compte.connexion.motDePasseOublie': "🔑 Passwort vergessen?",
  'compte.connexion.bouton': "🔓 Anmelden",
  'compte.connexion.enCours': "⏳ Anmeldung läuft…",
  'compte.connexion.ouContinuerAvec': "Oder weiter mit",
  'compte.connexion.pasDeCompte': "Noch kein Konto?",
  'compte.connexion.creerUnCompte': "Konto erstellen",
  'compte.connexion.erreur': "Ungültige Zugangsdaten. Bitte versuchen Sie es erneut.",
  'compte.connexion.erreurGoogle': "Bei der Anmeldung mit Google ist ein Fehler aufgetreten.",
  'compte.inscription.seoTitre': "Registrieren",
  'compte.inscription.seoDescription': "Erstellen Sie Ihr Mirum-Games-Konto.",
  'compte.inscription.titre': "Registrieren",
  'compte.inscription.sousTitre': "Werden Sie Teil der Mirum-Games-Gemeinschaft",
  'compte.champ.nomComplet': "Vollständiger Name",
  'compte.champ.nomCompletPlaceholder': "Anna Müller",
  'compte.champ.creerMotDePasse': "Wählen Sie ein sicheres Passwort",
  'compte.champ.confirmation': "Passwort bestätigen",
  'compte.champ.confirmationPlaceholder': "Bestätigen Sie Ihr Passwort",
  'compte.force.faible': "❌ Schwach",
  'compte.force.moyen': "⚠️ Mittel",
  'compte.force.fort': "✅ Stark",
  'compte.inscription.accepteLes': "Ich akzeptiere die",
  'compte.inscription.conditions': "Allgemeinen Geschäftsbedingungen",
  'compte.inscription.etLa': "und die",
  'compte.inscription.politique': "Datenschutzerklärung",
  'compte.inscription.bouton': "🎮 Konto erstellen",
  'compte.inscription.enCours': "⏳ Konto wird erstellt…",
  'compte.inscription.dejaUnCompte': "Sie haben bereits ein Konto?",
  'compte.inscription.seConnecter': "Anmelden",
  'compte.inscription.erreurMotsDePasse': "Die Passwörter stimmen nicht überein.",
  'compte.inscription.erreurConditions': "Bitte akzeptieren Sie die Geschäftsbedingungen.",
  'compte.inscription.erreurLongueur': "Das Passwort muss mindestens 6 Zeichen lang sein.",
  'compte.inscription.erreur': "Bei der Registrierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  'compte.profil.deconnexion': "Abmelden",
  'compte.profil.mesCommandes': "📦 Meine Bestellungen",
  'compte.profil.informations': "👤 Angaben",
  'compte.profil.informationsTitre': "Persönliche Angaben",
  'compte.commandes.chargement': "Bestellungen werden geladen…",
  'compte.commandes.aucune': "Sie haben noch keine Bestellung aufgegeben.",
  'compte.commandes.decouvrir': "Unsere Produkte entdecken",
  'compte.commandes.articles': "Artikel:",
  'compte.commandes.total': "Gesamt:",
  'compte.commandes.suiviLabel': "Sendungsnr.:",
  'compte.commandes.suivre': "Mein Paket verfolgen",
  'compte.commandes.facture': "Rechnung herunterladen",
  "compte.commandes.noteCredit": "Gutschrift",
  'compte.commandes.avis': "Bewertung schreiben",
  'compte.commandes.nonAuthentifie': "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  'compte.commandes.erreur': "Beim Laden Ihrer Bestellungen ist ein Fehler aufgetreten",
  'compte.statut.paid': "Bezahlt",
  'compte.statut.shipped': "Versandt",
  'compte.statut.delivered': "Geliefert",
  'compte.statut.cancelled': "Storniert",
  'compte.infos.general': "Allgemeine Angaben",
  'compte.infos.nomComplet': "Vollständiger Name *",
  'compte.infos.emailFige': "Die E-Mail-Adresse kann nicht geändert werden",
  'compte.infos.adresseLivraison': "Lieferadresse",
  'compte.infos.adresse': "Adresse",
  'compte.infos.adressePlaceholder': "Straße und Hausnummer",
  'compte.infos.ville': "Ort",
  'compte.infos.codePostal': "Postleitzahl",
  'compte.infos.pays': "Land",
  'compte.infos.choisirPays': "Land auswählen",
  'compte.infos.telephone': "Telefon",
  'compte.infos.enregistrer': "💾 Speichern",
  'compte.infos.enregistrement': "⏳ Wird gespeichert…",
  'compte.infos.succes': "✅ Ihr Profil wurde aktualisiert.",
  'compte.infos.erreur': "❌ Beim Aktualisieren Ihres Profils ist ein Fehler aufgetreten",
  "maFacture.seoTitre": "Meine Rechnung finden - Mirum Games",
  "maFacture.seoDescription": "Finden Sie die Rechnung zu Ihrer Mirum-Games-Bestellung mit Ihrer Bestellnummer und Ihrer E-Mail-Adresse.",
  "maFacture.titre": "Meine Rechnung finden",
  "maFacture.intro": "Sie haben ohne Kundenkonto bestellt und finden die Bestätigungs-E-Mail nicht mehr? Geben Sie Ihre Bestellnummer und die beim Kauf verwendete E-Mail-Adresse ein.",
  "maFacture.champNumero": "Bestell- oder Rechnungsnummer",
  "maFacture.champNumeroAide": "Sie steht in der Bestätigungs-E-Mail und auf der Seite, die nach der Zahlung angezeigt wurde.",
  "maFacture.champEmail": "Beim Kauf verwendete E-Mail-Adresse",
  "maFacture.bouton": "Meine Rechnung finden",
  "maFacture.recherche": "Suche läuft…",
  "maFacture.introuvable": "Wir finden keine Bestellung mit diesen Angaben. Prüfen Sie die Nummer und die beim Kauf verwendete E-Mail-Adresse.",
  "maFacture.tropDEssais": "Zu viele Versuche hintereinander. Bitte warten Sie eine Minute und versuchen Sie es dann erneut.",
  "maFacture.erreur": "Die Suche ist fehlgeschlagen. Versuchen Sie es gleich noch einmal oder schreiben Sie uns.",
  "maFacture.facture": "Ihre Rechnung Nr. {numero} liegt bereit.",
  "maFacture.voirFacture": "🧾 Rechnung ansehen und drucken",
  "maFacture.langueDocument": "Die Rechnung ist auf Französisch ausgestellt. Sie können sie in Ihrem Browser drucken oder als PDF speichern.",
  "maFacture.factureStripe": "🧾 Rechnung zu dieser Bestellung ansehen",
  "maFacture.enAttente": "Ihre Zahlung ist noch nicht eingegangen: Wir schicken Ihnen die Rechnung per E-Mail, sobald sie da ist.",
  "maFacture.aucune": "Zu dieser Bestellung gibt es keine Online-Rechnung. Schreiben Sie uns, wir schicken sie Ihnen zu.",
  "maFacture.voirNote": "Gutschrift Nr. {numero}",
  "maFacture.compte": "Sie haben ein Kundenkonto? Alle Ihre Rechnungen finden Sie unter",
};
